import type { Currency } from "./currency.vo";

export class Money {
  private constructor(
    private readonly _amount: number,
    private readonly _currency: Currency,
  ) {}

  public get amount() {
    return this._amount;
  }

  public get amountUnit() {
    return this._amount / 10 ** this._currency.minorUnit;
  }

  static create(amount: number, currency: Currency): Money {
    const rounded = currency.round(amount);
    return new Money(rounded, currency);
  }

  static createByUnit(amountUnit: number, currency: Currency): Money {
    const rounded = currency.toMinorUnit(amountUnit);
    return new Money(rounded, currency);
  }

  format(locale?: string): string {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: this._currency.alphabeticalCode,
    }).format(this.amountUnit);
  }
}
